import {Injectable} from '@angular/core';
import {BBRestEndpointService} from '../@modules/bb-rest/bb-rest-endpoint.service';
import {JobTitle} from '../@models/job-title.model';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class JobTitleDBService {
  prefix = 'job-titles';
  jobTitleMap: { [pk: number]: JobTitle.Model } = {};

  constructor(private api: BBRestEndpointService) {
  }

  search(keywords: string, limit: number = 12): Observable<JobTitle.Model> {
    return this.api.getLimitedRecords<number>(this.prefix, {is_shown: true}, '-frequency',
      {search: keywords, pksOnly: true}, limit)
      .concatMap(pk => this.get(pk));
  }

  get(pk: number) {
    if (this.jobTitleMap[pk]) {
      return Observable.of(this.jobTitleMap[pk]);
    } else {
      return this.api.run_detail('GET', this.prefix, pk)
        .do(job => this.jobTitleMap[job.pk] = job);
    }
  }
}
